import { ReferralPage } from '#/views/referral'

export async function getServerSideProps({ params }: { params: Promise<{ email: string }> }) {
	return { props: { email: (await params).email } }
}

export default ReferralPage
